import { Route, Routes } from "react-router-dom";
import { Routes as FleetTireRoutes } from "./routes";
import { FleetTireRouterCmp } from "./types";
// import { TireDetailPage } from "../pages/TireDetailPage";
import { TireSetSearchPage } from "../pages/TireSetSearchPage";
import { TireSetDetailPage } from "../pages/TireSetDetailPage";
import { TireSetDocumentSearchPage } from "../pages/TireSetDetailPage/components/TireSetDocumentSearchPage";
import { TireSearchPage } from "../pages/TireSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetTireRouter: FleetTireRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={TireSetSearchPage.route} element={<TireSetSearchPage />} />
        <Route path={TireSetDetailPage.route} element={<TireSetDetailPage />} />
        <Route path={TireSetDocumentSearchPage.route} element={<TireSetDocumentSearchPage />} />
        <Route path={TireSearchPage.route} element={<TireSearchPage />} />
        {/* <Route path={TireDetailPage.route} element={<TireDetailPage />} /> */}
      </Routes>
    </>
  );
};

FleetTireRouter.route = FleetTireRoutes.FleetTireRouter;

export default FleetTireRouter;
